export const saudiCitiesAr = [
  { label: 'الرياض', value: 'Riyadh' },
  { label: 'الخرج', value: 'Al Kharj' },
  { label: 'المجمعة', value: 'Al Majma\'ah' },
  { label: 'الدوادمي', value: 'Al Dawadmi' },
  { label: 'عفيف', value: 'Afif' },
  { label: 'الزلفي', value: 'Zulfi' },
  { label: 'شقراء', value: 'Shaqra' },
  { label: 'حريملاء', value: 'Huraymila' },
  { label: 'القويعية', value: 'Al Qwai\'iyah' },
  { label: 'المزاحمية', value: 'Al Muzahmiyah' },
  { label: 'ثادق', value: 'Thadiq' },
  { label: 'حوطة بني تميم', value: 'Hotat Bani Tamim' },
  { label: 'الرماح', value: 'Al Rumah' },
  { label: 'وادي الدواسر', value: 'Wadi Al Dawasir' },
  { label: 'السليل', value: 'Al Sulayyil' },
  { label: 'الغاط', value: 'Al Ghat' },
  { label: 'المويه', value: 'Al Muwayh' },
  { label: 'تمير', value: 'Tameer' },
  { label: 'ساجر', value: 'Sajar' },
  { label: 'عيون الجواء', value: 'Uyun Al Jiwa' },
  { label: 'رماح', value: 'Rumah' },
  { label: 'حوطة سدير', value: 'Hautat Sudair' },
  { label: 'مكة المكرمة', value: 'Mecca' },
  { label: 'جدة', value: 'Jeddah' },
  { label: 'الطائف', value: 'Taif' },
  { label: 'القنفذة', value: 'Al Qunfudhah' },
  { label: 'رابغ', value: 'Rabigh' },
  { label: 'خليص', value: 'Khulais' },
  { label: 'الكامل', value: 'Kamil' },
  { label: 'أضم', value: 'Adham' },
  { label: 'الخرمة', value: 'Al Khurmah' },
  { label: 'الليث', value: 'Al Leith' },
  { label: 'رنية', value: 'Ranyah' },
  { label: 'الجموم', value: 'Al Jumum' },
  { label: 'تربة', value: 'Turbah' },
  { label: 'المظيلف', value: 'Al Muzaylif' },
  { label: 'غميقة', value: 'Ghamighah' },
  { label: 'بني مالك', value: 'Bani Malik' },
  { label: 'بني سعد', value: 'Bani Saad' },
  { label: 'بني الحارث', value: 'Bani Al Harith' },
  { label: 'بني زيد', value: 'Bani Zaid' },
  { label: 'المدينة المنورة', value: 'Medina' },
  { label: 'ينبع', value: 'Yanbu' },
  { label: 'بدر', value: 'Badr' },
  { label: 'العلا', value: 'Al Ula' },
  { label: 'خيبر', value: 'Khaybar' },
  { label: 'الحناكية', value: 'Al Hanakiya' },
  { label: 'المهد', value: 'Al Mahd' },
  { label: 'وادي الفرع', value: 'Wadi Al Far\'a' },
  { label: 'المليليح', value: 'Al Mulayhah' },
  { label: 'بريدة', value: 'Buraidah' },
  { label: 'عنيزة', value: 'Unayzah' },
  { label: 'المذنب', value: 'Al Mudhahab' },
  { label: 'الرس', value: 'Al Rass' },
  { label: 'البدائع', value: 'Al Bada\'' },
  { label: 'البكيرية', value: 'Al Bukayriyah' },
  { label: 'الشماسية', value: 'Al Shamasiya' },
  { label: 'الدائر', value: 'Al Da\'ir' },
  { label: 'الحائط', value: 'Al Ha\'it' },
  { label: 'الدمام', value: 'Dammam' },
  { label: 'الخبر', value: 'Khobar' },
  { label: 'الظهران', value: 'Dhahran' },
  { label: 'الجبيل', value: 'Jubail' },
  { label: 'الأحساء', value: 'Al Ahsa' },
  { label: 'القطيف', value: 'Al Qatif' },
  { label: 'حفر الباطن', value: 'Hafr Al Batin' },
  { label: 'رأس تنورة', value: 'Ras Tanura' },
  { label: 'الخفجي', value: 'Al Khafji' },
  { label: 'بقيق', value: 'Buqayq' },
  { label: 'قرية العليا', value: 'Qurayyat Al Ulya' },
  { label: 'النعيرية', value: 'Al Nairyah' },
  { label: 'الجبيل الصناعية', value: 'Jubail Industrial City' },
  { label: 'أبها', value: 'Abha' },
  { label: 'خميس مشيط', value: 'Khamis Mushait' },
  { label: 'محايل', value: 'Muhayil' },
  { label: 'رجال ألمع', value: 'Rijal Almaa' },
  { label: 'بارق', value: 'Bariq' },
  { label: 'تنومة', value: 'Tanomah' },
  { label: 'النماص', value: 'Al Namas' },
  { label: 'بلقرن', value: 'Balqarn' },
  { label: 'سراة عبيدة', value: 'Sarat Abidah' },
  { label: 'طريب', value: 'Turaib' },
  { label: 'تبوك', value: 'Tabuk' },
  { label: 'ضباء', value: 'Duba' },
  { label: 'أملج', value: 'Umluj' },
  { label: 'الوجه', value: 'Al Wajh' },
  { label: 'حقل', value: 'Haql' },
  { label: 'البدع', value: 'Al Bada' },
  { label: 'مقنا', value: 'Maqna' },
  { label: 'شواق', value: 'Shawak' },
  { label: 'تيماء', value: 'Tayma' },
  { label: 'حائل', value: 'Hail' },
  { label: 'بقعاء', value: 'Buq\'ah' },
  { label: 'الشملي', value: 'Al Shamli' },
  { label: 'السليمي', value: 'Al Sulami' },
  { label: 'الغزالة', value: 'Al Ghazalah' },
  { label: 'عرعر', value: 'Arar' },
  { label: 'رفحاء', value: 'Rafha' },
  { label: 'طريف', value: 'Turaif' },
  { label: 'القريات', value: 'Al Qurayyat' },
  { label: 'طبرجل', value: 'Tabarjal' },
  { label: 'دومة الجندل', value: 'Dumat Al Jandal' },
  { label: 'الحديثة', value: 'Al Haditha' },
  { label: 'جازان', value: 'Jazan' },
  { label: 'صبيا', value: 'Sabya' },
  { label: 'أبو عريش', value: 'Abu Arish' },
  { label: 'الداير', value: 'Al Dayer' },
  { label: 'فرسان', value: 'Farasan' },
  { label: 'بيش', value: 'Bishah' },
  { label: 'العيدابي', value: 'Al Idabi' },
  { label: 'أحد المسارحة', value: 'Ahad Al Masarih' },
  { label: 'صامطة', value: 'Samtah' },
  { label: 'الدرب', value: 'Al Darb' },
  { label: 'نجران', value: 'Najran' },
  { label: 'شرورة', value: 'Sharurah' },
  { label: 'حبونا', value: 'Habuna' },
  { label: 'يدمة', value: 'Yadama' },
  { label: 'الخرخير', value: 'Al Khurkhir' },
  { label: 'ثار', value: 'Thar' },
  { label: 'الباحة', value: 'Al Baha' },
  { label: 'بلجرشي', value: 'Baljurashi' },
  { label: 'المندق', value: 'Al Mandaq' },
  { label: 'القرى', value: 'Al Qura' },
  { label: 'المخواة', value: 'Al Mikhwah' },
  { label: 'الحجرة', value: 'Al Hajrah' },
  { label: 'سكاكا', value: 'Sakakah' },
  { label: 'اللقائط', value: 'Al Liqait' },
  { label: 'الفويلق', value: 'Al Fuweilat' }
];

export const saudiCitiesEn = saudiCitiesAr.map(city => ({
  label: city.value,
  value: city.value
}));
